import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { YouTubeVideo } from './youtube-video.model';

const YOUTUBE_API_KEY = 'AIzaSyDKiKQx_aq12ERiwZ8e_hDc2kfRigcMmTI';
const YOUTUBE_API_URL = 'https://www.googleapis.com/youtube/v3/search';

@Injectable({
  providedIn: 'root',
})
export class YouTubeService {
  httpBackend = inject(HttpBackend);
  private http: HttpClient;
  constructor() {
    this.http = new HttpClient(this.httpBackend);
  }

  search(query: string): Observable<YouTubeVideo[]> {
    const params: string = [
      `q=${query.replace(' ', '+')}`,
      `key=${YOUTUBE_API_KEY}`,
      `part=snippet`,
      `type=video`,
      `maxResults=10`,
      `order=relevance`,
    ].join('&');

    const queryUrl = `${YOUTUBE_API_URL}?${params}`;

    return this.http
      .get<{
        items: {
          id: { videoId: string };
          snippet: { title: string; description: string; thumbnails: { high: { url: string } } };
        }[];
      }>(queryUrl)
      .pipe(
        map((response) =>
          response.items.map(
            (item) =>
              new YouTubeVideo({
                id: item.id.videoId,
                title: item.snippet.title,
                description: item.snippet.description,
                thumbnailUrl: item.snippet.thumbnails.high.url,
              })
          )
        )
      );
  }
}
